import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { FEATURE_FLAGS_FROM_STATE, FeatureFlagNamesType } from 'yeself-common/typings/FeatureFlags';

import { makeSelectFeatureIsEnabled } from '../FeatureFlagsSelector';

type FeatureProps<T = JSX.Element> = {
    name: FeatureFlagNamesType;
    children: T;
};

type FeatureReturnType<T = JSX.Element> = React.ReactElement<FeatureProps<T>, any> | null;

const Feature = <T,>({ name, children }: FeatureProps<T>): FeatureReturnType<T> => {
    const selectIsFeatureFlagEnabled = useMemo(makeSelectFeatureIsEnabled, []);

    const isFeatureEnabled = useSelector((state: { featureFlags: typeof FEATURE_FLAGS_FROM_STATE }) =>
        selectIsFeatureFlagEnabled(state, name)
    );

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return isFeatureEnabled ? <>{children}</> : null;
};

export default Feature;
